import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import GuestRegisterDialog from 'components/GuestRegisterDialog';
import OfferPanel from 'components/OfferPanel';
import CampaignCorner, { CouponSellerTag, getCampaignTheme, campaignFrameStyle } from 'components/CampaignFrame';
import { Carousel, CarouselItem, Col, Row } from 'reactstrap';
import { NavLink, useLocation } from 'react-router-dom';
import AppConfig from 'constants/config'
import './index.css'
import moment from 'moment'
import { getProductDetails, togglePopup } from 'actions/buyer';
import { connect } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import CartPopOver from './CartPopOver'
import helpertFn from 'constants/helperFunction';
import Fab from '@mui/material/Fab';
const logo = 'https://s3.ap-south-1.amazonaws.com/medideals.assets/PLACEHOLER.JPG';

const ListCard = (props) => {
  const location = useLocation()
  const [activeIndex, setActiveIndex] = useState(0)
  const [popoverOpen, setPopoverOpen] = useState(false)
  const [showRegisterDialog, setShowRegisterDialog] = useState(false)

  const buyerToken = localStorage.getItem('buyer_token');
  const tempToken = localStorage.getItem('temp_token');
  const isBuyerLoggedIn = Boolean(buyerToken);
  const shouldBlur = !buyerToken && !tempToken;

  // Safe toFixed helper
  const safeToFixed = (val, digits = 2) => {
    const num = Number(val);
    return isNaN(num) ? '-' : num.toFixed(digits);
  }

  function toggle() { setPopoverOpen(!popoverOpen) }

  function next(size) {
    if (size === 1) { setActiveIndex(0); }
    else if (activeIndex === 0) { setActiveIndex(activeIndex + 1); }
  }

  function previous(size) {
    if (size === 1) { setActiveIndex(0); }
    else if (activeIndex === 0) { setActiveIndex(activeIndex - 1); }
  }

  const handleNavClick = () => {
    props.getProductDetails({ inventory_id: props.product.inventory_id })
  }

  function addDefaultSrc(ev) {
    ev.target.src = 'https://s3.ap-south-1.amazonaws.com/medideals.assets/PLACEHOLER.JPG'
  }

  const closepop = () => {
    setPopoverOpen(false)
  }

  const { product, identifier } = props
  const discount = product && product.Discount && product.Discount;
  const otherProduct = product ? product.OtherProducts ? product.OtherProducts : '' : '';
  const inventoryID = product && product.inventory_id;
  // Campaign colour set for the frame and the corner ribbon (see components/CampaignFrame). Null
  // when the listing carries no product-tier campaign.
  const campaign = getCampaignTheme(product);
  const chemCombination = product && product.Product && product.Product.chem_combination
  const productMRP = product && product.MRP
  const productName = product && product.Product && product.Product.name && ((product.Product.name).replace(/ /g, '-')).replace(/[\/,  @#%\^;?]/g, ' ').toLowerCase()
  const bgColor = product && (product.medi_type === 'Ethical branded' || product.medi_type === 'Others') ? '#ff7000' : product.medi_type === 'Cool chain' ? '#0b68a8' :
    product.medi_type === 'Surgical' || product.medi_type === 'OTC' || product.medi_type === 'Generic' ? '#038d0e' : '#072791'

  const slides = product ? product ? product.Product ? product.Product.images.length > 0 ? product.Product.images.map((image, index) => {
    return (
      <CarouselItem key={index}>
        <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${product.inventory_id}`} onClick={handleNavClick}>
          <img src={product.Product.images.length === 0 ? logo : `${helpertFn.productImg(image)}`} onError={addDefaultSrc} alt="logo" />
        </NavLink>
      </CarouselItem>
    )
  }) : [<CarouselItem key={"index"}>
    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${product.inventory_id}`} onClick={handleNavClick}>
      <img src={product.Product.images.length === 0 ? logo : `${AppConfig.productImageUrl}/}`} alt="logo" />
    </NavLink>
  </CarouselItem>] : [<CarouselItem key={"index"}>
    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${product.inventory_id}`} onClick={handleNavClick}>
      <img src={product.Product.images.length === 0 ? logo : `${AppConfig.productImageUrl}/}`} alt="logo" />
    </NavLink>
  </CarouselItem>] : [<CarouselItem key={"index"}>
    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${product.inventory_id}`} onClick={handleNavClick}>
      <img src={product.Product.images.length === 0 ? logo : `${AppConfig.productImageUrl}/}`} alt="logo" />
    </NavLink>
  </CarouselItem>] : [<CarouselItem key={"index"}>
    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${product.inventory_id}`} onClick={handleNavClick}>
      <img src={product.Product.images.length === 0 ? logo : `${AppConfig.productImageUrl}/}`} alt="logo" />
    </NavLink>
  </CarouselItem>]

  // Dummy price section for blur
  const DummyPriceSection = () => (
    <div>
      <div className='pl-3'>
        <span className='discountPrice'>Buy 10 Get 2 Free</span>
      </div>
      <div className='pl-3'>
        <span className='priceColor'>₹ 999.99</span>&nbsp;
        <span className='originalPrice font'>₹ 1299.99</span>&nbsp;
        <span className='discountPrice'>Min: 10, Max: 100</span>
      </div>
    </div>
  );

  // Real price section
  const RealPriceSection = () => (
    <>
      {discount && discount.discount_type === "Same" ?
        <React.Fragment>
          <div className='pl-3'>
            <span className={'discountPrice'}>Buy {discount.discount_on_product.purchase} Get {discount.discount_on_product.bonus} Free</span>
          </div>
          <div className='pl-3'>
            <span className={'priceColor'}>&#x20B9;{safeToFixed(product.ePTR)}</span>
            <span style={{ marginTop: '2px' }}>&nbsp;
              <span className={'originalPrice font'}>&#x20B9;{safeToFixed(product.PTR)}</span>&nbsp;
              <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
            </span>
          </div>
        </React.Fragment>
        :
        discount && discount.discount_type === "SameAndDiscount" ?
          <React.Fragment>
            <div className='pl-3'>
              <Tooltip
                className="d-inline-block"
                id="tooltip-right"
                title={<span style={{ marginTop: "13px" }}>Buy {discount.discount_on_product.purchase} Get {discount.discount_on_product.bonus} Free, and {safeToFixed(product.Discount.discount_per)}% Off</span>}
                placement="right"
              >
                <span className={'discountPrice ellipsis w-100'}>Buy {discount.discount_on_product.purchase} Get {discount.discount_on_product.bonus} Free, and {safeToFixed(product.Discount.discount_per)}% Off</span>
              </Tooltip>
            </div>
            <div className='pl-3'>
              <span className={'priceColor'}>&#x20B9;{safeToFixed(product.ePTR)}</span>&nbsp;
              <span style={{ marginTop: '2px' }}>&nbsp;
                <span className={'originalPrice font'}>&#x20B9;{safeToFixed(product.PTR)}</span>&nbsp;
                <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
              </span>
            </div>
          </React.Fragment>
          :
          discount && discount.discount_type === "Discount" ?
            <React.Fragment>
              <div className='pl-3'>
                <span>Get {safeToFixed(product.Discount.discount_per)}% discount</span>
              </div>
              <div className='pl-3'>
                <span className={'priceColor'}>₹{safeToFixed(product.ePTR)}</span>&nbsp;
                <span style={{ marginTop: '2px' }}>&nbsp;
                  <span className={'originalPrice font'}>₹{safeToFixed(product.PTR)}</span>&nbsp;
                  <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
                </span>
              </div>
            </React.Fragment>
            :
            discount && discount.discount_type === "Different" ?
              <React.Fragment>
                <div className='pl-3'>
                  <Tooltip
                    className="d-inline-block"
                    id="tooltip-right"
                    title={<h6 className="text-white" style={{ marginTop: "13px" }}>Buy {discount.discount_on_product.purchase} Get {discount.discount_on_product.bonus} {otherProduct.name} Free</h6>}
                    placement="right"
                  >
                    <span className={'discountPrice ellipsis w-100'}>
                      {("Buy " + discount.discount_on_product.purchase + " Get " + discount.discount_on_product.bonus + " " + otherProduct.name + " Free").slice(0, 25) + "..."}
                    </span>
                  </Tooltip>
                </div>
                <div className='pl-3'>
                  <span className={'priceColor'}>₹{safeToFixed(product.ePTR)}</span>&nbsp;
                  <span style={{ marginTop: '2px' }}>
                    <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
                  </span>
                </div>
              </React.Fragment>
              :
              discount && discount.discount_type === "DifferentAndDiscount" ?
                <React.Fragment>
                  <div className='pl-3'>
                    <Tooltip
                      className="d-inline-block"
                      id="tooltip-right"
                      title={<h6 className="text-white" style={{ marginTop: "13px" }}>Buy {discount.discount_on_product.purchase} Get {discount.discount_on_product.bonus} {otherProduct.name} Free, and {safeToFixed(product.Discount.discount_per)}% Off</h6>}
                      placement="right"
                    >
                      <span className={'discountPrice ellipsis w-100'}>
                        {("Buy " + discount.discount_on_product.purchase + " Get " + discount.discount_on_product.bonus + " " + otherProduct.name + " Free, and " + safeToFixed(product.Discount.discount_per) + "% Off").slice(0, 25) + "..."}
                      </span>
                    </Tooltip>
                  </div>
                  <div className='pl-3'>
                    <span className={'priceColor'}>₹{safeToFixed(product.ePTR)}</span>&nbsp;
                    <span className={'discountPrice'} style={{ marginTop: '2px' }}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
                  </div>
                </React.Fragment>
                :
                discount && discount.discount_type === "" ?
                  <React.Fragment>
                    <div className='pl-3 mt-3'></div>
                    <div className='pl-3'>
                      <span className={'priceColor'}>₹{safeToFixed(product.ePTR)}</span>&nbsp;
                      <span style={{ marginTop: '2px' }}>&nbsp;
                        <span className={'originalPrice font'}>{product.MRP === product.PTR ? null : "₹" + safeToFixed(product.MRP)}</span>&nbsp;
                        <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
                      </span>
                    </div>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <div className='pl-3 mt-3'></div>
                    <div className='pl-3'>
                      <span className={'priceColor'}>₹{safeToFixed(product.ePTR)}</span>&nbsp;
                      <span style={{ marginTop: '2px' }}>
                        <span className={'discountPrice'}>Min: {product.min_order_quantity}, Max: {product.max_order_quantity}</span>
                      </span>
                    </div>
                  </React.Fragment>
      }
    </>
  );

  return (
    <React.Fragment>
      <div className='flex-con jr-card p-0' style={{ minHeight: '170px', ...campaignFrameStyle(campaign) }}>
        {/* `.jr-card` is `position: relative` with the global $border-radius (0.375rem), not the
            buyer card's 2rem, so the ribbon clips itself to a 6px corner here. Compact size: the
            row is only 170px tall. */}
        <CampaignCorner product={product} blur={shouldBlur} size="compact" radius={6} giftOnly />
        <div style={{ maxWidth: '20%' }}>
          <div style={{ position: 'relative', display: 'inline-flex', overflow: 'hidden', maxHeight: '100%' }}>
            <Carousel
              autoPlay={false}
              indicators={true}
              activeIndex={activeIndex}
              next={() => next(slides.length)}
              interval={false}
              previous={() => previous(slides.length)}
              className='itemImage'
            >
              {slides}
            </Carousel>
            <span style={{ padding: '2px', fontWeight: 'bold', position: 'absolute', zIndex: 1, backgroundColor: `${bgColor}`, color: 'white', width: 'auto', maxHeight: '40px' }} className='itemImage'>
              {product && product.medi_type === 'Others' ? 'PCD' : product.medi_type}
            </span>
          </div>
        </div>

        <div style={{ width: '80%' }} className='pl-4'>
          <Row>
            <Col md={6} xl={6} lg={6} sm={12} xs={6}>
              <div className='pt-2 pb-2'>
                {product && product.Product && product.Product.name.length > 40 ?
                  <Tooltip className="d-inline-block" id="tooltip-right"
                    title={<h6 className="text-white" style={{ marginTop: "5px" }}>{product && product.Product && product.Product.name}</h6>}
                    placement="right"
                  >
                    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${inventoryID}`} onClick={handleNavClick}>
                      <h2 className="card-title card-titleIntranet ellipsis w-100" style={{ minHeight: "20px", maxHeight: "20px", overflow: "hidden", marginTop: "5px" }}>
                        {product && product.Product && product.Product.name}
                      </h2>
                    </NavLink>
                  </Tooltip>
                  :
                  <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${inventoryID}`} onClick={handleNavClick}>
                    <h2 className="card-title card-titleIntranet ellipsis w-100" style={{ minHeight: "20px", maxHeight: "20px", overflow: "hidden", marginTop: "5px" }}>
                      {product && product.Product && product.Product.name}
                    </h2>
                  </NavLink>
                }
              </div>
            </Col>
            <Col md={6} xl={6} lg={6} sm={12} xs={6}></Col>
          </Row>

          <Row>
            <Col md={6} xl={6} lg={6} sm={12} xs={6}>
              {/* Same pairing as the grid card: name left, tag pushed to the right end of the row by
                  its own `marginLeft: auto`. Right end of THIS column, not of the whole list row -
                  the other half already carries the Jumbo Deal / Only Prepaid chips, and the coupon
                  belongs on the seller's line. The name is truncated at 25 characters below, so the
                  two fit the half-width column together. */}
              <div className='pb-2 pt-2' style={{ display: 'flex', alignItems: 'center' }}>
                <NavLink className="buyerRedirectNavlink" to={`/view-seller/${product && product.Seller && product.Seller._id}`} style={{ minHeight: "43px", flex: '0 1 auto', minWidth: 0 }}>
                  <Chip
                    label={(product && product.Seller && product.Seller.company_name.length) > 25 ?
                      (product && product.Seller && product.Seller.company_name).slice(0, 24) + "..." : product && product.Seller && product.Seller.company_name}
                    size='small'
                  />
                </NavLink>
                <CouponSellerTag product={product} blur={shouldBlur} />
              </div>
            </Col>
            <Col md={6} xl={6} lg={6} sm={12} xs={6} className='pl-0 pt-1 pr-0'>
              {product && product.medi_attribute.includes('Jumbo Deal') &&
                <span size='small' className='text-white' style={{ backgroundColor: `${bgColor}`, margin: "0px", padding: "3px 5px" }}>Jumbo Deal</span>
              }&nbsp;
              {helpertFn.showPrepaid(product.medi_type, product.Product.isPrepaid && product.Product.isPrepaid, product.prepaidInven && product.prepaidInven) &&
                <span className='text-white bg-danger' style={{ margin: "0px", padding: "3px 5px" }}>Only Prepaid</span>
              }
            </Col>
          </Row>

          <Row>
            <Col md={6} xl={6} lg={6} sm={12} xs={6}>
              <div>
                <p className={location.pathname.includes('/view-seller') ? 'pt-1' : ''} style={{ minHeight: "10px", marginBottom: "0px" }}>
                  MRP: ₹{safeToFixed(productMRP)}
                </p>
              </div>
            </Col>
            <Col md={6} xl={6} lg={6} sm={12} xs={6} className='pl-0'>
              <div className='pl-3'>
                Expiry Date: {product && product.expiry_date && moment(product.expiry_date).format('D MMM, YYYY')}
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={6} xl={6} lg={6} sm={12} xs={6}>
              <div>
                {chemCombination.length > 35 ?
                  <React.Fragment>
                    <Tooltip className="d-inline-block" id="tooltip-right"
                      title={<h6 className="text-white" style={{ marginTop: "5px" }}>{product && product.Product && product.Product.chem_combination}</h6>}
                      placement="right"
                    >
                      <p className={`ellipsis w-100 pt-1`} style={{ minHeight: "25px", marginBottom: "5px" }}>{chemCombination}</p>
                    </Tooltip>
                  </React.Fragment>
                  :
                  <p className='pt-1' style={{ minHeight: "46px", marginBottom: "5px" }}>{chemCombination}</p>
                }
              </div>
            </Col>

            {/* ✅ Price & Offer Section — Blur for non-logged-in users */}
            <Col md={6} xl={6} lg={6} sm={12} xs={6} className='pl-0'>
              <div style={{ position: 'relative' }}>
                {/* Product-tier coupon/gift only, shown the same way as the main product card
                    (OfferPanel). Blurred for logged-out guests, matching the price section. */}
                <div className='pl-3'>
                  <OfferPanel product={product} blur={shouldBlur} style={{marginRight:"10px"}} />
                </div>
                {shouldBlur ? (
                  <>
                    {/* Blurred dummy data */}
                    <div style={{ filter: 'blur(4px)', userSelect: 'none', pointerEvents: 'none' }}>
                      <DummyPriceSection />
                    </div>
                    {/* Login overlay */}
                    <div
                      style={{
                        position: 'absolute',
                        top: 0, left: 0, right: 0, bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                      }}
                      onClick={props.togglePopup}
                    >
                    </div>
                  </>
                ) : (
                  <RealPriceSection />
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={8} xl={8} lg={8} sm={12} xs={8}>
              {location.pathname.includes('/view-company') ? null :
                <div>
                  <p className="d-flex mb-0 align-items-baseline">
                    By
                    <NavLink className="buyerRedirectNavlink" to={`/view-company/${product.Company._id}`}>
                      <h5 className="text-primary ml-1" style={{ minHeight: "25px", maxHeight: "25px", overflow: "hidden", marginBottom: "5px" }}>
                        {product && product.Company && product.Company.name}
                      </h5>
                    </NavLink>
                  </p>
                </div>
              }
            </Col>
            <Col md={4} xl={4} lg={4} sm={12} xs={4} style={{ textAlign: 'end', marginTop: '-15px' }}>
              <div className='pr-3 pb-2'>
                {shouldBlur ? (
                  // Show deals button for non-logged-in users
                  <button
                    style={{ fontSize: "12px", padding: '6px 10px', backgroundColor: '#072791', color: 'white', borderRadius: '5px', border: 'none' }}
                    onClick={props.togglePopup}
                  >
                    Show deals
                  </button>
                ) : (
                  <>
                    <Fab className="jr-badge-up" style={{ backgroundColor: `${bgColor}`, color: 'white', width: '40px', height: '40px' }}>
                      <i className="zmdi zmdi-shopping-cart"
                        style={{ float: "right", fontSize: '20px' }}
                        onClick={isBuyerLoggedIn ? toggle : () => setShowRegisterDialog(true)}
                        id={"lc1" + inventoryID + identifier}
                      />
                    </Fab>
                    {isBuyerLoggedIn && (
                      <Popover placement="left" isOpen={popoverOpen} target={"lc1" + inventoryID + identifier} toggle={toggle}
                        style={{ padding: "5px", paddingBottom: "0px", textAlign: "center", backgroundColor: '#fff' }}>
                        <PopoverHeader style={{ padding: "4px 4px", textAlign: "center" }}>Select Quantity</PopoverHeader>
                        <CartPopOver closepop={closepop} dataFromParent={product} />
                        <PopoverBody style={{ paddingBottom: 0, textAlign: "center" }}></PopoverBody>
                      </Popover>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <GuestRegisterDialog open={showRegisterDialog} onClose={() => setShowRegisterDialog(false)} />
    </React.Fragment>
  );
}

const mapStateToProps = ({ buyer }) => {
  const { data, otherSellers, relatedProducts, productData } = buyer;
  return { data, otherSellers, relatedProducts, productData }
};

export default connect(mapStateToProps, { getProductDetails, togglePopup })(ListCard);